var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M4.9 2.833v.463H1.167l2.128 2.128a.232.232 0 1 1-.325.326L.444 3.231l-.16-.166.16-.167L2.97.38a.232.232 0 0 1 .188-.072h.022a.232.232 0 0 1 .115.398L1.167 2.833H4.9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M5.582 0A.683.683 0 0 0 4.9.682V5.46h4.67L7.48 3.37a.225.225 0 0 1 0-.32.225.225 0 0 1 .32 0l2.638 2.638-2.637 2.637a.222.222 0 0 1-.157.071.238.238 0 0 1-.163-.07.225.225 0 0 1 0-.32l2.09-2.091H4.9v4.778c0 .376.306.682.682.682h7.736a.683.683 0 0 0 .682-.682V.683A.683.683 0 0 0 13.318 0H5.582zM4.9 5.915V5.46H2.852a.228.228 0 0 0 0 .455H4.9z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    transform: "translate(0 2.625)",
    xlinkHref: "#a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterFilled);
export default __webpack_public_path__ + "static/media/enter-filled.becca189d9702cedf8a1b08424d8db8c.svg";
export { ForwardRef as ReactComponent };